<template>
  <div class="visits" v-if="!isEdit && !isAdd">
    <div class="left-tree">
      <Tree
        @changeSwitch="changeSwitch"
        :switchVal="switchVal"
        @nodeClick="nodeClick"
      ></Tree>
    </div>
    <div class="right-content">
      <TabelSearch
        :searchConfig="searchConfig"
        :searchParams="searchParams"
        @resetCallBack="resetCallBack"
        @search="setSearchParams"
      ></TabelSearch>
      <Table
        :width="'100%'"
        :tableLoading="tableLoading"
        :tabelButtons="tabelButtons"
        :templateData="tableTemplateData"
        :tableConfig="tableConfig"
        :pagination="pagination"
      >
      </Table>
    </div>
  </div>
  <div class="detail-page" v-else>
    <div class="back-btn">
      <span @click="closeDialog" class="backbtn">微服务</span>
      <span class="el-icon-arrow-right" style="margin: 0 5px"></span>
      <span style="color: #333">发布内容</span>
    </div>
    <xlDetail
      :disabled="detailDisabled"
      :info="detailInfo"
      @closeAddPage="closeAddPage"
    />
  </div>
</template>

<script>
import Tree from "../../../../components/Tree/nodeTree";
import TabelSearch from "../../../../components/tabel-search/tabel-search";
import xlDetail from "./detail.vue";
import { mediaApi } from "../../../../api-path/media-api.js";
export default {
  components: {
    Tree,
    TabelSearch,
    xlDetail,
  },
  data() {
    return {
      tagList: [],
      switchVal: false,
      isEdit: false, //是否编辑状态
      isAdd: false, //是否新增状态
      detailDisabled: false,
      detailInfo: {},
      //表格**********start
      searchConfig: {
        dataName: "searchParams",
        items: [
          {
            key: "serverType",
            valueType: "select",
            placeholder: "选择栏目",
            option: {
              label: "itemName",
              value: "itemValue",
            },
            data: JSON.parse(localStorage.getItem("codeData"))["GROUP_CONTROLLER"],
          },
          {
            placeholder: "开始时间:结束时间",
            valueType: "datetimerange",
            key: "date",
          },
          {
            key: "search",
            valueType: "text",
            placeholder: "发布人/文章标题搜索",
          },
        ],
      },
      searchParams: {
        areaId: "",
        isDown: false,
        serverType: "",
        date: [],
        search: "",
        page: 1,
        size: 15,
      },
      tableLoading: false,
      tabelButtons: [
        {
          type: "add",
          title: "新增",
          fn: (data) => {
            this.isAdd = true;
            this.detailDisabled = false;
            this.detailInfo = {
              areaId: "",
              areaName: "",
              author: "",
              content: "",
              coverImg: "",
              imgList: [],
              id: "",
              major: "",
              playUrl: "",
              publishTime: "",
              serverType: [],
              title: "",
              type: "",
              unit: "",
              videoList: [],
              draft: false, //是否为草稿
            };
          },
        },
        {
          type: "forbidden", //
          title: "批量禁用",
          fn: (data) => {
            console.log(data);
            let result = data.map((item) => {
              return item.id;
            });
            this.$http
              .post(mediaApi.groupConEnabled, { ids: result, enabled: false })
              .then((res) => {
                if (res.status == 200) {
                  this.$message.success("操作成功！");
                  this.setSearchParams();
                }
              });
          },
        },
      ],
      tableTemplateData: [],
      tableConfig: {
        checkbox: true,
        checkboxFn: () => {},
        rows: [
          {
            label: "发布区域",
            prop: "areaName",
          },
          {
            label: "标题",
            prop: "title",
          },
          {
            label: "发布人",
            prop: "author",
          },
          {
            label: "发布单位",
            prop: "unit",
          },
          {
            label: "发布时间",
            prop: "createGmt",
          },
          {
            label: "状态",
            prop: "status",
            type: "status",
            activeText: "已发布",
            text: "未发布",
          },
          {
            label: "是否禁用",
            type: "status",
            prop: "enabled",
            activeColor: "",
            activeText: "已启用",
            text: "已禁用",
            showWord: false,
            fn: (data) => {
              const that = this;
              this.$confirm(`确认${data.enabled ? "禁用" : "启用"}该条信息`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  that.$http
                    .post(mediaApi.groupConEnabled, {
                      enabled: !data.enabled,
                      ids: [data.id],
                    })
                    .then((res) => {
                      if (res.status === 200) {
                        that.$message.success("操作成功");
                        that.setSearchParams();
                      }
                    });
                })
                .catch(() => {
                  that.$message({
                    type: "info",
                    message: "已取消操作",
                  });
                });
            },
          },
        ],
        rowButtons: {
          width: "200px",
          items: [
            {
              label: "查看",
              showkey: "btnCheck",
              fn: (data) => {
                this.$http
                  .get(mediaApi.groupConDetail, { params: { id: data.id } })
                  .then((res) => {
                    if (res.status == 200) {
                      let result = JSON.parse(JSON.stringify(res.result));
                      result.imgList = result.coverImg.split(",");
                      result.imgList = result.imgList.map((item) => {
                        return {
                          url: item,
                        };
                      });
                      result.videoList = result.playUrl.split(",");
                      result.videoList = result.videoList.map((item) => {
                        return {
                          url: item,
                          suffixTypeValue: "video",
                        };
                      });
                      result.serverType = result.serverType
                        ? result.serverType.split(",")
                        : [];
                      this.detailInfo = result;
                      this.isEdit = true;
                      this.detailDisabled = true;
                    }
                  });
              },
            },
            {
              label: "编辑",
              showkey: "btnEdit",
              fn: (data) => {
                this.$http
                  .get(mediaApi.groupConDetail, { params: { id: data.id } })
                  .then((res) => {
                    if (res.status == 200) {
                      let result = JSON.parse(JSON.stringify(res.result));
                      result.imgList = result.coverImg.split(",");
                      result.videoList = result.playUrl.split(",");
                      result.videoList = result.videoList.map((item) => {
                        return {
                          url: item,
                          suffixTypeValue: "video",
                        };
                      });
                      result.serverType = result.serverType
                        ? result.serverType.split(",")
                        : [];
                      this.detailInfo = result;
                      this.isEdit = true;
                      this.detailDisabled = false;
                    }
                  });
              },
            },
            {
              label: "删除",
              type: "danger",
              fn: (data) => {
                this.$confirm("此操作将删除该条数据, 是否继续?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    this.$http
                      .get(mediaApi.groupConDel, { params: { id: data.id } })
                      .then((res) => {
                        if (res.status === 200) {
                          this.$message.success("删除成功");
                          this.setSearchParams();
                        }
                      });
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: "已取消删除",
                    });
                  });
              },
            },
          ],
        },
      },
      pagination: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange,
        pageChange: this.pageChange,
      },
      //***********表格end
    };
  },
  created() {},
  methods: {
    closeDialog() {
      this.isAdd = false;
      this.isEdit = false;
    },
    closeAddPage(value) {
      this.isAdd = value;
      this.isEdit = value;
    },
    changeSwitch(e) {
      this.switchVal = e;
      this.searchParams.isDown = e;
      this.setSearchParams();
    },
    nodeClick(node) {
      this.areaId = node.id;
      this.searchParams.areaId = node.id;
      this.setSearchParams();
    },
    resetCallBack() {
      this.searchParams.time = "";
      this.searchParams.search = "";
      this.searchParams.page = this.pagination.page=1;
      this.searchParams.size = this.pagination.size=15;
      this.searchParams.areaId = this.areaId;
      this.searchParams.isDown = this.isDown;
      this.setSearchParams();
    },
    // 每页显示条数
    sizeChange(size) {
      this.pagination.size = size;
      this.searchParams.size = size;
      this.setSearchParams();
    },
    // 当前页
    pageChange(page) {
      this.pagination.page = page;
      this.searchParams.page = page;
      this.setSearchParams();
    },
    setSearchParams() {
      const { date, ...params } = { ...this.searchParams };
      params.startTime = date[0];
      params.endTime = date[1];
      this.$http.get(mediaApi.groupConList, { params }).then((res) => {
        if (res.status === 200) {
          res.result.pageList.map((item) => {
            item.btnEdit = !item.status;
            item.btnCheck = item.status;
          });
          this.tableTemplateData = res.result.pageList;
          this.pagination.total = res.result.total;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.visits {
  margin-left: 10px;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
  display: flex;
  .left-tree {
    margin-right: 10px;
    border-right: 1px solid #c1c1c1;
  }

  .right-content {
	flex: 1;
	display: flex;
	flex-direction: column;
  }
}
.detail-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .back-btn {
    height: 40px;
    margin-left: 10px;
    background-color: #fff;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    align-items: center;
    span {
      color: #999;
      font-size: 14px;
    }
    .backbtn {
      cursor: pointer;
      &:hover {
        color: #66b1ff;
      }
    }
  }
}
</style>
